<template>
  <div class="ce_text link-terms last block">
    <button @click="showInfoModal=true">Rechtliche Hinweise</button>
    <SimonModal
      :is-visible="showInfoModal"
      size="large"
      id="rechtlicheHinweise"
      @hide="showInfoModal = false"
      :aria-label-modal="getSlotText('lblTermsModal', 'Rechtliche Hinweise')"
    >
      <slot name="txtLegalTerms"></slot>
    </SimonModal>
  </div>
</template>

<script>
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'LinkTerms',
  components: {
    SimonModal
  },
  data () {
    return {
      showInfoModal: false
    }
  },
  mounted () {
  },
  computed: {},
  methods: {}
}
</script>
